import { render, staticRenderFns } from "./MandatePresenceLogs.vue?vue&type=template&id=1b32110f&"
import script from "./MandatePresenceLogs.vue?vue&type=script&lang=js&"
export * from "./MandatePresenceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports